export default __webpack_public_path__ + "static/media/icon-table-view-default.3c410b5d.svg";